export default __webpack_public_path__ + "static/media/about-team-ellen-foster.c25c34f1.png";